if (!customElements.get('cart-minimum-order-notice')) {
  class CartMinimumOrderNotice extends HTMLElement {
    connectedCallback() {
      this.updateFromDataset();
    }

    update(cartTotal) {
      const threshold = parseInt(this.dataset.minimumAmount, 10) || 0;
      const total = typeof cartTotal === 'number' ? cartTotal : parseInt(this.dataset.cartTotal, 10) || 0;
      const meets = total >= threshold;

      this.hidden = meets;
      if (meets) return;

      const remaining = Math.max(threshold - total, 0);
      const textEl = this.querySelector('.cart-minimum-order-notice__text');
      if (!textEl) return;

      const template = this.dataset.messageTemplate || '';
      const currencyFormat = window.theme?.settings?.money_with_currency_format || '${{amount}}';

      textEl.textContent = template
        .replace(/\{\{\s*amount\s*\}\}/g, formatMoney(threshold, currencyFormat))
        .replace(/\{\{\s*remaining\s*\}\}/g, formatMoney(remaining, currencyFormat));
    }

    updateFromDataset() {
      this.update(parseInt(this.dataset.cartTotal, 10) || 0);
    }
  }

  customElements.define('cart-minimum-order-notice', CartMinimumOrderNotice);
}

(function () {
  const config = window.theme?.cartMinimumOrder;
  if (!config?.enabled || !config.amount) return;

  const getThreshold = () => Math.round(config.amount * (Shopify.currency?.rate || 1));

  const getCartTotal = (event) => {
    if (typeof event?.cartData?.total_price === 'number') return event.cartData.total_price;
    const notice = document.querySelector('cart-minimum-order-notice');
    if (notice?.dataset?.cartTotal) return parseInt(notice.dataset.cartTotal, 10) || 0;
    const checkoutButton = document.querySelector('.cart__checkout-button[name="checkout"]');
    if (checkoutButton?.dataset?.cartTotal) return parseInt(checkoutButton.dataset.cartTotal, 10) || 0;
    return 0;
  };

  const meetsMinimum = (total) => total >= getThreshold();

  const updateCheckoutButtons = (total) => {
    const eligible = meetsMinimum(total) && total > 0;

    document.querySelectorAll('.cart__checkout-button[name="checkout"]').forEach((button) => {
      button.disabled = !eligible;
      button.setAttribute('aria-disabled', eligible ? 'false' : 'true');
    });

    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((wrapper) => {
      wrapper.hidden = !eligible;
    });

    document.querySelectorAll('cart-minimum-order-notice').forEach((notice) => {
      if (typeof notice.update === 'function') notice.update(total);
    });
  };

  const blockCheckoutSubmit = (event) => {
    const form = event.target;
    if (!form?.querySelector?.('[name="checkout"]')) return;

    const submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;

    const total = getCartTotal();
    if (!meetsMinimum(total)) {
      event.preventDefault();
      event.stopPropagation();

      const notice = document.querySelector('cart-minimum-order-notice:not([hidden])');
      notice?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
    }
  };

  const init = (event) => {
    updateCheckoutButtons(getCartTotal(event));
    attachFormGuards();
  };

  const attachFormGuards = () => {
    document.querySelectorAll('#cart, #CartDrawer-Form').forEach((form) => {
      if (form.dataset.minimumOrderGuard) return;
      form.dataset.minimumOrderGuard = 'true';
      form.addEventListener('submit', blockCheckoutSubmit);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
    attachFormGuards();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, init);
  }

  document.addEventListener('cartUpdated', init);
})();
